import { Button } from "antd";
import React, { ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";

type RegisterCardProps = {
  title: string;
  icon: ReactNode;
  href: string;
};

const RegisterCard: React.FC<RegisterCardProps> = ({ title, icon, href }) => {
  const navigate = useNavigate();
  return (
    <div className="w-[175px] h-[240px] shadow-lg rounded-lg flex flex-col items-center justify-around">
      <div className="flex flex-row justify-center items-center bg-[#FAEECA] w-[100px] h-[100px] rounded-full">
        {icon}
      </div>
      <div className="font-extrabold text-lg">{title}</div>
      <Button
        type="primary"
        onClick={() => navigate(href)}
        className="px-4 py-2 text-white bg-green-400"
      >
        Subscribe
      </Button>
      {/* <Link to={href} className="px-4 py-2 rounded-md text-white bg-green-400">Register</Link> */}
    </div>
  );
};

export default RegisterCard;
